/**
 * The eventTarget function returns the window object of the event target.
 * If there is no event target, it returns the current window.
 *
 * @returns The window object if the popup is not opened
 */
function eventTarget() {
  if (window.opener && !window.opener.closed) {
    return window.opener;
  }
  return window;
}

/**
 * The triggerEvent function is used to send a message to the parent window.
 * It was written in db-bot-webclient to expect a dbNav type, a dbNav value and an
 * optional dbNav title.
 *
 * @param {string} type - Specify the type of event that is being triggered
 * @param {string} value - Pass the value for the type property
 * @param {string | null} title - Pass the title of the page to redirect to
 *
 * @returns A postMessage event to a parent window
 */
function triggerEvent(type, value, title = null) {
  eventTarget()
    .postMessage({
      type,
      value,
      title,
    }, '*');
}

/**
 * This code defines a function named executeWindowEvent that takes two parameters:
 * dbNav and dbNavTitle.
 *
 * It checks if dbNav is a string and starts with a forward slash.
 * If it does, it calls the triggerEvent function with the parameters 'dbNav', dbNav, and dbNavTitle
 * (unless dbNavTitle is equal to 'NA', in which case it passes null as the third parameter).
 *
 * @param {string} dbNav - Determine if the event should be triggered
 * @param {string} dbNavTitle - Set the title of the page
 */
function executeWindowEvent(dbNav, dbNavTitle) {
  if (dbNav && typeof dbNav === 'string' && dbNav.startsWith('/')) {
    triggerEvent('dbNav', dbNav, dbNavTitle !== 'NA' ? dbNavTitle : null);
  }
}

export default executeWindowEvent;
